import { render, staticRenderFns } from "./QuestionConfirm.vue?vue&type=template&id=ad3a2d6e&scoped=true&"
import script from "./QuestionConfirm.vue?vue&type=script&lang=ts&"
export * from "./QuestionConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionConfirm.vue?vue&type=style&index=0&id=ad3a2d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3a2d6e",
  null
  
)

export default component.exports